import { render } from "./cp_login.vue?vue&type=template&id=770608fe&scoped=true"
import script from "./cp_login.vue?vue&type=script&lang=js"
export * from "./cp_login.vue?vue&type=script&lang=js"

import "./cp_login.vue?vue&type=style&index=0&id=770608fe&lang=css"
import "./cp_login.vue?vue&type=style&index=1&id=770608fe&scoped=scope&lang=less"

import exportComponent from "E:\\Work\\Code\\HZY.Student\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-770608fe"]])

export default __exports__